function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  filter: "url(#filter0_d)"
}, React.createElement("rect", {
  x: 5,
  y: 3,
  width: 34,
  height: 34,
  rx: 6,
  fill: "#269969"
}), React.createElement("path", {
  d: "M28.2637 21.9471C28.5449 21.6659 28.5449 21.2112 28.2637 20.9299C27.9824 20.6487 27.5277 20.6487 27.2465 20.9299L22.0001 26.1763L16.7538 20.9299C16.4725 20.6487 16.0179 20.6487 15.7366 20.9299C15.5963 21.0702 15.5258 21.2544 15.5258 21.4385C15.5258 21.6227 15.5963 21.8069 15.7366 21.9471L21.4915 27.7021C21.7728 27.9833 22.2275 27.9833 22.5087 27.7021L28.2637 21.9471Z",
  fill: "white"
}), React.createElement("path", {
  d: "M22.5087 20.5085L28.2637 14.7535C28.5449 14.4723 28.5449 14.0176 28.2637 13.7363C27.9824 13.4551 27.5277 13.4551 27.2465 13.7363L22.0001 18.9827L16.7538 13.7363C16.4725 13.4551 16.0179 13.4551 15.7366 13.7363C15.5963 13.8766 15.5258 14.0608 15.5258 14.2449C15.5258 14.4291 15.5963 14.6133 15.7366 14.7535L21.4915 20.5085C21.7728 20.7897 22.2275 20.7897 22.5087 20.5085Z",
  fill: "white"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "filter0_d",
  x: 0,
  y: 0,
  width: 44,
  height: 44,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feMorphology", {
  radius: 1,
  operator: "erode",
  in: "SourceAlpha",
  result: "effect1_dropShadow"
}), React.createElement("feOffset", {
  dy: 2
}), React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
}), React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

var SvgReplenishment = function SvgReplenishment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgReplenishment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/replenishment.1fd7e91f.svg";
export { ForwardRef as ReactComponent };